import moment from "moment"

export const checkDate = (start, start_time, end, end_time, fixedHour) => {
  let startTime = ""
  let endTime = ""

  if (!start_time) {
    startTime = `${start}T${fixedHour || "00:00:00"}`
  } else {
    if (start) {
      startTime = `${start}T${fixedHour || start_time + ":00"}`
    } else {
      startTime = `${start}T${fixedHour || "00:00:00"}`
    }
  }

  if (!end_time) {
    if (end) {
      endTime = `${end}T${fixedHour || "00:00:00"}`
    } else {
      endTime = `${start}T${fixedHour || "00:00:00"}`
    }
  } else {
    if (end) {
      endTime = `${end}T${fixedHour || end_time + ":00"}`
    } else {
      endTime = `${start}T${fixedHour || end_time + ":00"}`
    }
  }

  if(end && !end_time){
    endTime = `${end}T${fixedHour || start_time + ":00"}`
  }

  return {
    startTime,
    endTime,
  }
}

export const setPreValuesEventClick = (
  setValue,
  description,
  type,
  setEventClickInfo,
  clickInfo,
  recurrence,
) => {
  const { event } = clickInfo
  console.log("dt", event.startStr)
  setValue("title", event.title)
  setValue("start_time", moment.utc(event.startStr).format("HH:mm"))
  setValue("end_time", event.endStr && moment.utc(event.endStr).format("HH:mm"))
  setValue("start", moment.utc(event.startStr).format("YYYY-MM-DD"))
  setValue("end", moment.utc(event.endStr).format("YYYY-MM-DD"))
  setValue("description", description || null)
  setValue("recurrence", `${recurrence}` || null)
  setValue("type", type)
  setEventClickInfo({
    clickInfo,
    state: "update",
  })
}

export const setPreValuesDateSelect = (setValue, event, setEventClickInfo, user, scope) => {
  setEventClickInfo({ state: "create" })
  setValue("title", "")
  setValue("type", "")
  setValue("start", moment.utc(event.dateStr).format("YYYY-MM-DD") || "")
  setValue("end", "")
  setValue(
    "start_time",
    event.view.type !== "dayGridMonth" ? moment.utc(event.dateStr).format("HH:mm") : "",
  )
  setValue("end_time", "")
  setValue("description", "")
  setValue("userId", user.id)
  setValue("projectId", scope?.id)
}

export const formatDateCalendarEvents = (calendarEvents, formatCurrentDateClicked) => {
  return (
    calendarEvents.length &&
    calendarEvents?.filter(
      (event) =>
        event.start.includes(formatCurrentDateClicked) ||
        event.end?.includes(formatCurrentDateClicked) ||
        moment(formatCurrentDateClicked).isBetween(
          moment(event?.start).format("YYYY-MM-DD"),
          moment(event?.end).format("YYYY-MM-DD"),
        ),
    )
  )
}

export const typeEventsCalendar = (typeEvent) => {
  const typeEventTrailOrContent = typeEvent === "Envio de Conteúdo" || typeEvent === "Envio de Trilha"
  const typeEventContent = typeEvent === "Envio de Conteúdo"
  const typeEventTrail = typeEvent === "Envio de Trilha"
  const typeEventSector = typeEvent === "Mudança de setor"
  const typeEventEsm = typeEvent === "Evento Esm"

  return { typeEventContent, typeEventTrailOrContent, typeEventTrail, typeEventSector, typeEventEsm }
}

export const resetFieldsCalendar = (setValue, setAllPosts, setTagsProject, setEventClickInfo, reset, setEventId, setSelectedPosts, setSelectedOption, setTypeEvent) => {
  setValue("title", "")
    setValue("start_time", "")
    setValue("recurrence", "")
    setTypeEvent("")
    setSelectedOption("")
    setEventId("")
    setSelectedPosts([])
    setAllPosts([])
    setTagsProject([])
    setEventClickInfo({})
    reset({ keepErrors: false })
}

